/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { Tabs, Typography } from '@neo4j-ndl/react';
import { useState } from 'react';

const Component = () => {
  const [value, setValue] = useState<string>('0');

  return (
    <div className="n-w-80">
      <Tabs value={value} onChange={setValue} className="n-mb-token-8">
        <Tabs.Tab id="0">Tab 1</Tabs.Tab>
        <Tabs.Tab id="1">Tab 2</Tabs.Tab>
        <Tabs.Tab id="2">Tab 3</Tabs.Tab>
        <Tabs.Tab id="3">Tab 4</Tabs.Tab>
        <Tabs.Tab id="4">Tab 5</Tabs.Tab>
        <Tabs.Tab id="5">Tab 6</Tabs.Tab>
        <Tabs.Tab id="6">Tab 7</Tabs.Tab>
        <Tabs.Tab id="7">Tab 8</Tabs.Tab>
        <Tabs.Tab id="8">Tab 9</Tabs.Tab>
        <Tabs.Tab id="9">
          Tab 10 is waay too long and will be cut off on smaller screens
        </Tabs.Tab>
      </Tabs>
      <Tabs.TabPanel value={value} tabId="0">
        <Typography variant="body-medium">Tab 1 content</Typography>
      </Tabs.TabPanel>
      <Tabs.TabPanel value={value} tabId="1">
        <Typography variant="body-medium">Tab 2 content</Typography>
      </Tabs.TabPanel>
      <Tabs.TabPanel value={value} tabId="2">
        <Typography variant="body-medium">Tab 3 content</Typography>
      </Tabs.TabPanel>
      <Tabs.TabPanel value={value} tabId="3">
        <Typography variant="body-medium">Tab 4 content</Typography>
      </Tabs.TabPanel>
      <Tabs.TabPanel value={value} tabId="4">
        <Typography variant="body-medium">Tab 5 content</Typography>
      </Tabs.TabPanel>
      <Tabs.TabPanel value={value} tabId="5">
        <Typography variant="body-medium">Tab 6 content</Typography>
      </Tabs.TabPanel>
      <Tabs.TabPanel value={value} tabId="6">
        <Typography variant="body-medium">Tab 7 content</Typography>
      </Tabs.TabPanel>
      <Tabs.TabPanel value={value} tabId="7">
        <Typography variant="body-medium">Tab 8 content</Typography>
      </Tabs.TabPanel>
      <Tabs.TabPanel value={value} tabId="8">
        <Typography variant="body-medium">Tab 9 content</Typography>
      </Tabs.TabPanel>
      <Tabs.TabPanel value={value} tabId="9">
        <Typography variant="body-medium">Tab 10 content</Typography>
      </Tabs.TabPanel>
    </div>
  );
};

export default Component;
